class GWPDiscount {
  constructor() {
    this.cart = null;
    this.discounts =
      (window.GisouDiscounts ? window.GisouDiscounts.FGWP : []) || [];
    this.maxAppliedPerCart = 1;
    this.discountsApplied = 0;
    this.discountsToShow = [];
    this.discountsToApply = [];
    this.discountsToDelete = [];
    this.discountsToUpdate = [];
    this.inCartRemoveSelectors = [
      ".cart__remove",
      ".variant_price-item-large",
      "select.qty-selector",
      ".qty-title-large",
    ];
    this.discountMessageSelector = [".cart-product-meta-default"];
  }

  get() {
    return this.discounts;
  }

  init(forceCartReload = true) {
    console.log('%c Init GWP! ', 'padding: 3px; font-size: 15px; background: #222; color: #ffcc00');
    const _self = this;

    _self.discountsToApply = [];
    _self.discountsToDelete = [];
    _self.discountsToUpdate = [];

    return new Promise((resolve, reject) => {
      _self.loadCart(forceCartReload).then(() => {
        if (!_self.discounts?.length) {
          _self.cart.items.forEach((item) => {
            if (item.properties['_gwp_enabled'] === 'yes') {
              _self.discountsToDelete.push({free_product_key: item.key});
            }
          })
        }

        // Remove discounts that are not available
        _self.cart.items.forEach((item) => {
          const existingDiscount = _self.discounts.find((discount) => discount.free_product === item.id.toString());
          if (item.properties["_gwp_enabled"] === "yes" && !existingDiscount) {
            _self.discountsToDelete.push({ free_product_key: item.key });
          }
        });
        
        _self.discounts.forEach((discount) => {
          _self.verify(discount);
        });

        if (_self.discountsToApply.length || _self.discountsToDelete.length || _self.discountsToUpdate.length) {
          _self.process();
          resolve(true);
        }

        // Display GWP message
        _self.drawCartBanner();
      });
    });
  }

  initializeEvents() {
    document.addEventListener("product:added", this.init);
    document.addEventListener("product:changed", this.init);
  }

  verify(discount) {
    const _self = this;

    let freeGiftItemIndex = this.cart.items.findIndex(
      (item) => item.id.toString() === discount.free_product && item.properties['_gwp_enabled'] === 'yes'
    );

    this.discountsApplied = this.cart.items.reduce((discounts, item) => {
      if (item.id.toString() === discount.free_product && item.properties['_gwp_enabled'] === 'yes') {
        _self.discountsToShow.push(discount);
        discounts += item.quantity;
      }
      return discounts;
    }, 0);

    if (freeGiftItemIndex >= 0) {
      discount.free_product_key = this.cart.items[freeGiftItemIndex].key;
    }

    if (this.discountsApplied > this.maxAppliedPerCart) {
      this.discountsToUpdate.push(discount);
    }
    if (this.canApply(discount)) {
      if (freeGiftItemIndex < 0 || this._validateAppliedLimit()) {
        this.discountsToApply.push(discount);
      }
    } else {
      if (freeGiftItemIndex >= 0) {
        // remove free gift from cart
        this.discountsToDelete.push(discount);
      }
    }
  }

  canApply(discount) {
    return (
      this._validateAvailability(discount) &&
      this._validateDateInterval(discount) &&
      this._validateMinPurchaseAmmount(discount) &&
      this._validateProductInCart(discount) &&
      this._validateProductsInCart(discount)
    );
  }

  process() {
    const _self = this;
    // Discounts to apply
    let items = [];
    let properties = {
      _gwp_enabled: "yes",
    };

    _self.discountsToApply.forEach((discount) => {
      // properties[discount.property_key] = discount.description;
      properties["description"] = discount.description;
      // properties['_gwp_key'] = discount.property_key;
      items.push({
        id: discount.free_product,
        quantity: 1,
        properties: properties,
      });
    });

    // Discounts to delete
    let updates = {};

    // Updates
    _self.discountsToUpdate.forEach((discount) => {
      updates[discount.free_product_key] = 1;
    });

    _self.discountsToDelete.forEach((discount) => {
      updates[discount.free_product_key] = 0;
    });

    if (items.length) {
      localStorage.setItem("is_adding_discount", "true");

      _self
        .addDiscountItemsToCart(items)
        .then((response) => {
          if (!_self._isCartPage()) {
            _self.updateCart();
            setTimeout(() => {
              _self.updateCart();
              document.documentElement.dispatchEvent(
                new CustomEvent("cartEvent:updateCarts")
              );
              // document.location = "/cart";
            }, 500);
          } else {
            setTimeout(() => {
              document.location = "/cart";
            }, 500);
          }
        })
        .catch((error) => {
          console.error("ERROR: ", error);
        });
    }

    if (JSON.stringify(updates) !== "{}") {
      localStorage.setItem("is_adding_discount", "true");

      _self
        .updateDiscountItemsInCart(updates)
        .then((response) => {
          if (_self._isCartPage()) {
            setTimeout(() => {
              document.location = "/cart";
            }, 500);
          } else {
            Object.keys(updates).forEach((key) => {
              const v = document.querySelector(
                `[data-ajax-cart-template-variant-id="${key}"]`
              );
              if (v) {
                v.parentNode.remove();
              }
            });
          }
        })
        .catch((error) => {
          console.error("ERROR: ", error);
        });
    }
  }

  appliedDiscounts() {
    return this.discountsToApply.length || this.discountsToDelete.length;
  }

  _validateAppliedLimit(discount) {
    return this.maxAppliedPerCart > this.discountsApplied;
  }

  _validateAvailability(discount) {
    return discount.free_product_available === "true";
  }

  _validateDateInterval(discount) {
    return this._isValidStartDate(discount) && this._isValidEndDate(discount);
  }

  _validateMinPurchaseAmmount(discount) {
    if ("min_purchase_amount" in discount) {
      let minPurchaseAmount = discount.min_purchase_amount;
      // let cartTotal = this.cart.total_price / 100;
      let cartTotal = this._getCartTotal(discount);

      return (
        this._validateProductTypeinCart(discount) &&
        parseFloat(minPurchaseAmount) <= cartTotal
      );
    }

    return true;
  }

  _validateProductTypeinCart(discount) {
    if (
      "enable_product_types" in discount &&
      "product_types" in discount &&
      discount.enable_product_types === "true"
    ) {
      let cart = this.cart;
      let productIndex = cart.items.findIndex((item) => {
        let variantId = item.id.toString();
        let discountInCart =
          discount.product_types.indexOf(item.product_type) >= 0 ||
          item.product_type.indexOf(discount.product_types) >= 0;

        return variantId !== discount.free_product && discountInCart;
      });

      return productIndex >= 0;
    }

    return true;
  }

  _validateProductInCart(discount) {
    const skusToExclude = discount.exclude_skus || "";
    if ("buy_product" in discount) {
      let cart = this.cart;
      let productIndex = cart.items.findIndex( (item) => {
        return skusToExclude.indexOf(item.sku) == -1 && item.product_id.toString() == discount.buy_product
      });

      return productIndex >= 0;
    }

    return true;
  }

  _validateProductsInCart(discount) {
    let cart = this.cart;
    const skusToExclude = discount.exclude_skus || "";

    if ("buy_product_x" in discount && "buy_product_y" in discount) {
      let productIndex_x = cart.items.findIndex(
        (item) => item.product_id.toString() === discount.buy_product_x
      );
      let productIndex_y = cart.items.findIndex((item) => {
        if (discount.buy_product_y == "") {
          return (
            skusToExclude.indexOf(item.sku) == -1 &&
            item.product_id.toString() !== discount.buy_product_x
          );
        } else {
          return (
            skusToExclude.indexOf(item.sku) == -1 &&
            item.product_id.toString() === discount.buy_product_y
          );
        }
      });

      return productIndex_x >= 0 && productIndex_y >= 0;
    }

    return true;
  }

  _isValidStartDate(discount) {
    let currentDate = Date.now(),
      promoStartDate = Date.parse(
        `${discount.start_date.trim()} ${discount.start_time.trim()}`
      );

    if (!discount.start_date.trim()) {
      return true;
    }

    return !isNaN(promoStartDate) && currentDate >= promoStartDate;
  }

  _isValidEndDate(discount) {
    let currentDate = Date.now(),
      promoEndDate = Date.parse(
        `${discount.end_date.trim()} ${discount.end_time.trim()}`
      );

    if (!discount.end_date.trim()) {
      return true;
    }

    return isNaN(promoEndDate) || currentDate <= promoEndDate;
  }

  addDiscountItemsToCart(formData) {
    return new Promise((resolve, reject) => {
      if (!formData.length) {
        resolve(true);
      }
      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: formData }),
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          resolve(json);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  updateDiscountItemsInCart(formData) {
    return new Promise((resolve, reject) => {
      if (!formData.length) {
        resolve(true);
      }
      jQuery
        .post("/cart/update.js", { updates: formData })
        .done(function (data) {
          resolve(true);
        });
    });
  }

  // CART API
  loadCart(forceUpdate = false) {
    if (forceUpdate) {
      this.cart = null;
    }
    return this._getAjaxCart();
  }

  updateCart() {
    const _self = this;
    this._getAjaxCart().then((cart) => {
      _self.cart = cart;
    });
  }

  _getAjaxCart() {
    const _self = this;

    return new Promise((resolve, reject) => {
      if (_self.cart) {
        resolve(_self.cart);
      } else {
        $.get({
          url: "/cart.js",
          async: false,
          dataType: "json",
          success: (cart) => {
            _self.cart = cart;
            resolve(cart);
          },
        });
      }
    });
  }

  _isCartPage() {
    const templateCart = document.querySelector("body.template-cart");

    return templateCart;
  }

  _getCartTotal(discount) {
    const _self = this;
    const skusToExclude = discount.exclude_skus || "";
    let cartTotal = _self.cart.total_price;

    _self.cart.items.forEach((item) => {
      if (skusToExclude.indexOf(item.sku) >= 0 || item.gift_card) {
        cartTotal -= item.final_line_price;
      }
    });

    return cartTotal / 100;
  }

  drawCartBanner() {
    const _self = this;
    const cartBanner = document.querySelector(".cart-gwp");
    const template = window.window.gwpTemplate;
    const discount = _self.discounts.find(
      (item) => item.type == "fgwp_minimum_purchase"
    );

    if (!discount) {
      return;
    }
    
    const cartTotal = _self._getCartTotal(discount);
    if (cartBanner && discount) {
      const stringListToReplace = [
        "logo",
        "title",
        "warning",
        "free_product_name",
        "image",
      ];
      const awayToGetTheFreeGift = discount.min_purchase_amount - cartTotal;
      const stringListToReplaceWith = {
        logo: discount.logo,
        title: discount.description,
        warning:
          awayToGetTheFreeGift > 0
            ? `You’re ${window.currency_symbol}${awayToGetTheFreeGift.toFixed(0)} ${locale == 'fr' ? 'Loin' : 'Away'}`
            : "",
        free_product_name: `1x ${discount.free_product_name}`,
        image: discount.free_product_image,
      };

      const templateRendered = template.replace(
        /\|\*(.*?)\*\|/g,
        (match, key) => {
          if (stringListToReplace.includes(key)) {
            if (key == "image") {
              return `<img src="${stringListToReplaceWith[key]}" alt="${stringListToReplaceWith[key]}" />`;
            }
            return stringListToReplaceWith[key];
          }
          return match;
        }
      );
      if (awayToGetTheFreeGift > 0) {
        cartBanner.innerHTML = templateRendered;
      } else {
        cartBanner.innerHTML = templateRendered.replace(
          "no-success",
          "success"
        );
      }
    }
  }

  // drawCartBanner() {
  //   const _self = this;
  //   const cartBanner = document.querySelector(".cart-gwp");

  //   if (_self.discountsToShow.length > 0) {
  //     _self.discountsToShow.forEach((discount) => {
  //       cartBanner.innerHTML = _self.templateCart(discount);
  //     });
  //   }

  //   console.log(_self.discounts);
  // }

  templateCart(discount) {
    const template = window.gwpTemplate;
    const stringListToReplaceWith = {
      title: discount.description,
      warning: "",
      free_product_name: `1x ${discount.free_product_name}`,
      image: discount.free_product_image,
    };

    const templateRendered = template.replace(
      /\|\*(.*?)\*\|/g,
      (match, key) => {
        if (key in stringListToReplaceWith) {
          if (key == "image") {
            return `<img src="${stringListToReplaceWith[key]}" alt="${stringListToReplaceWith[key]}" />`;
          }
          return stringListToReplaceWith[key];
        }
        return match;
      }
    );

    return templateRendered.replace("no-success", "success");
  }
}

export default GWPDiscount;

